import axios from "axios"
import { createAsyncThunk } from "@reduxjs/toolkit"
import { getBaseEndpoint } from "../../features/endpoints/endpointManager"
import { EnumTableData } from "./schema"
import {
  contentManagementSlice,
  practiceTableDataUpdated,
  providerTableDataUpdated,
} from "./model"
import { apiService } from "../../features/shared/apiService"
import { DataStatus } from "../enums"

const getProviderTableDataEndpoint = getBaseEndpoint() + `/provider/tabledata`

export const fetchProviderTableData = createAsyncThunk(
  "providerHeader/getProviderTableData",
  async (_props, { dispatch }) => {
    try {
      dispatch(
        contentManagementSlice.actions.providerTableDataStatusUpdated(
          DataStatus.LOADING,
        ),
      )
      const response = await axios.get<EnumTableData>(
        getProviderTableDataEndpoint,
      )
      if (response.status === 200) {
        const payload: EnumTableData = response.data as EnumTableData
        dispatch(providerTableDataUpdated(payload))
        dispatch(
          contentManagementSlice.actions.providerTableDataStatusUpdated(
            DataStatus.LOADED,
          ),
        )
      } else {
        throw new Error(
          `Failed to get enum table data with status code: ${response.status}`,
        )
      }
    } catch (error) {
      dispatch(
        contentManagementSlice.actions.providerTableDataStatusUpdated(
          DataStatus.ERROR,
        ),
      )
      console.error(error)
    }
  },
)

export const fetchPracticeTableData = createAsyncThunk(
  "practiceHeader/getPracticeTableData",
  async (_props, { dispatch }) => {
    try {
      dispatch(
        contentManagementSlice.actions.practiceTableDataStatusUpdated(
          DataStatus.LOADING,
        ),
      )
      const payload = await apiService.practice.get.PRACTICE_TABLE_DATA()
      dispatch(practiceTableDataUpdated(payload))
      dispatch(
        contentManagementSlice.actions.practiceTableDataStatusUpdated(
          DataStatus.LOADED,
        ),
      )
    } catch (error) {
      dispatch(
        contentManagementSlice.actions.practiceTableDataStatusUpdated(
          DataStatus.ERROR,
        ),
      )
      console.error(error)
    }
  },
)
